/* ============================================================
 * LJ PACK BUILDER v2 — runtime
 * ============================================================
 * Mejoras vs v1:
 *  - Filtros chips por productType (Standard, Thumbs Up, Dog, Pup, etc.)
 *  - Panel derecho con lista de items seleccionados
 *  - Deselección: × en cada item del panel + click en card decrementa
 *  - Subtotal + Descuento + Total calculados en tiempo real
 *  - Mobile: bottom-sheet expandible + safe-area-inset-top
 *
 * SEGURIDAD: render via createElement + textContent (no innerHTML).
 * ============================================================ */

(function () {
  'use strict';

  /* ========== STATE ========== */
  var state = {
    activePack: null,
    products: [],            // flat array of all products in modal
    selection: [],           // [{handle, variantId, title, price, image, slotGroup}]
    productCache: {},
    slotGroups: [],
    activeFilter: 'all',     // 'all' | productType
    isOpen: false,
    /* Wizard mode (solo para multi-slot packs como Joe Club): cual paso esta
       activo. Para packs de un solo slot (joemania, bigfamily, etc.) este
       campo se ignora porque no hay pasos. */
    currentStep: 0,
    /* Track pack-completed transition para auto-scroll al CTA en mobile.
       Solo queremos scrollear cuando el pack PASA de incompleto a completo,
       no cuando ya estaba completo y user reemplaza un item. */
    wasReady: false,
  };

  /* ========== DOM REFS ========== */
  var modal, titleEl, subtitleEl, slotsEl, countEl, targetEl,
      productsEl, loadingEl, errorEl, addBtn, addLabelEl,
      filtersEl, summaryEl, itemsEl, itemsEmptyEl,
      subtotalEl, discountEl, discountRowEl, totalEl, sheetToggleEl,
      discountChipEl, discountBannerEl, discountBannerPercentEl,
      discountCircleEl, discountPctEl;

  function initRefs() {
    modal = document.getElementById('lj-pack-modal');
    if (!modal) return false;
    titleEl = modal.querySelector('[id="lj-pack-title"]');
    subtitleEl = modal.querySelector('.lj-pack-modal__subtitle');
    slotsEl = modal.querySelector('[data-lj-pack-slots]');
    countEl = modal.querySelector('[data-lj-pack-count]');
    targetEl = modal.querySelector('[data-lj-pack-target]');
    productsEl = modal.querySelector('[data-lj-pack-products]');
    loadingEl = modal.querySelector('[data-lj-pack-loading]');
    errorEl = modal.querySelector('[data-lj-pack-error]');
    addBtn = modal.querySelector('[data-lj-pack-add]');
    addLabelEl = modal.querySelector('[data-lj-pack-add-label]');
    filtersEl = modal.querySelector('[data-lj-pack-filters]');
    summaryEl = modal.querySelector('[data-lj-pack-summary]');
    itemsEl = modal.querySelector('[data-lj-pack-items]');
    itemsEmptyEl = modal.querySelector('[data-lj-pack-items-empty]');
    subtotalEl = modal.querySelector('[data-lj-pack-subtotal]');
    discountEl = modal.querySelector('[data-lj-pack-discount]');
    discountRowEl = modal.querySelector('[data-lj-pack-discount-row]');
    totalEl = modal.querySelector('[data-lj-pack-total]');
    sheetToggleEl = modal.querySelector('[data-lj-pack-sheet-toggle]');
    discountChipEl = modal.querySelector('[data-lj-pack-discount-chip]');
    discountBannerEl = modal.querySelector('[data-lj-pack-discount-banner]');
    discountBannerPercentEl = modal.querySelector('[data-lj-pack-discount-banner-percent]');
    /* Badge circular % de descuento (Pedro 2026-05-07) */
    discountCircleEl = modal.querySelector('[data-lj-pack-discount-circle]');
    discountPctEl = modal.querySelector('[data-lj-pack-discount-pct]');
    return true;
  }

  /* ========== UTILS ========== */
  function clearChildren(node) { while (node.firstChild) node.removeChild(node.firstChild); }

  function el(tag, opts) {
    var n = document.createElement(tag);
    if (!opts) return n;
    if (opts.cls) n.className = opts.cls;
    if (opts.text != null) n.textContent = String(opts.text);
    if (opts.attrs) {
      Object.keys(opts.attrs).forEach(function (k) {
        n.setAttribute(k, String(opts.attrs[k]));
      });
    }
    return n;
  }

  function priceFmt(soles) {
    return 'S/' + soles.toFixed(2);
  }

  /* ========== FETCH ========== */
  function fetchCollection(handle) {
    if (state.productCache[handle]) {
      return Promise.resolve(state.productCache[handle]);
    }
    var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=50';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var products = (data.products || []).map(function (p) {
          var v = p.variants && p.variants[0] ? p.variants[0] : null;
          return {
            id: p.id,
            handle: p.handle,
            title: p.title,
            product_type: p.product_type || '',
            variant_id: v ? v.id : null,
            price: v ? parseFloat(v.price) : 0,
            compare_at_price: v && v.compare_at_price ? parseFloat(v.compare_at_price) : null,
            image: p.images && p.images[0] ? p.images[0].src : null,
            /* available (Pedro 2026-05-11): si false, mostrar badge AGOTADO
               y bloquear seleccion. Antes el modal permitia clickear agotados
               y luego /cart/add.js fallaba con error "ya está agotado". */
            available: v ? (v.available !== false) : true,
          };
        });
        state.productCache[handle] = products;
        return products;
      });
  }

  function fetchEligibleProducts(pack) {
    if (pack.slot_collections) {
      var promises = pack.slot_collections.map(function (slot) {
        return Promise.all((slot.collections || []).map(fetchCollection))
          .then(function (results) {
            var merged = [];
            var seen = {};
            results.forEach(function (arr) {
              arr.forEach(function (p) {
                if (seen[p.handle]) return;
                /* Filtro 1: handle DEBE contener un substring (ej. "bolsa") */
                if (slot.filter_handle_includes &&
                    p.handle.indexOf(slot.filter_handle_includes) === -1) return;
                /* Filtro 2: handle DEBE empezar con un prefijo (ej. "little-joe-").
                   Util para Joe Club: las collections de equipos (alianza-lima,
                   universitario, sporting-cristal) contienen tanto los Joes como
                   las bolsas/llaveros del equipo. Filtramos para quedarnos solo
                   con los Joes (handle empieza con "little-joe-"). */
                if (slot.filter_handle_starts_with &&
                    p.handle.indexOf(slot.filter_handle_starts_with) !== 0) return;
                seen[p.handle] = true;
                merged.push(p);
              });
            });
            return {
              label: slot.label,
              step_pretitle: slot.step_pretitle || null,
              step_title: slot.step_title || null,
              products: merged
            };
          });
      });
      return Promise.all(promises);
    }
    return Promise.all((pack.collections || []).map(fetchCollection))
      .then(function (results) {
        var merged = [];
        var seen = {};
        results.forEach(function (arr) {
          arr.forEach(function (p) {
            if (seen[p.handle]) return;
            seen[p.handle] = true;
            merged.push(p);
          });
        });
        return [{ label: null, products: merged }];
      });
  }

  /* ========== FILTERS POR INTENSIDAD ========== */
  /* Resuelve la intensidad de un producto desde window.LJ_PACK_INTENSIDADES
     (mapping handle → 'Suave'|'Media'|'Intensa'). Si no está mapeado, retorna null. */
  function intensidadOf(handle) {
    var map = window.LJ_PACK_INTENSIDADES || {};
    return map[handle] || null;
  }

  function buildFilters(slotGroups) {
    /* Para multi-slot packs (Joe Club): no aplicamos filtros porque cada slot
       ya tiene categoría propia (bottle / bolsa / llavero). */
    if (state.activePack.slot_collections) {
      filtersEl.style.display = 'none';
      return;
    }
    filtersEl.style.display = '';

    /* Contar productos por intensidad (Suave / Media / Intensa) */
    var byIntensity = { 'Suave': 0, 'Media': 0, 'Intensa': 0 };
    var totalCount = 0;
    slotGroups.forEach(function (group) {
      group.products.forEach(function (p) {
        if (!p.variant_id) return;
        totalCount++;
        var i = intensidadOf(p.handle);
        if (i && byIntensity.hasOwnProperty(i)) byIntensity[i]++;
      });
    });

    clearChildren(filtersEl);
    /* "Todos" chip */
    var allChip = el('button', {
      cls: 'lj-pack-modal__chip is-active',
      text: 'Todos',
      attrs: { 'type': 'button', 'data-filter': 'all', 'role': 'tab', 'aria-selected': 'true' }
    });
    allChip.appendChild(el('span', { cls: 'lj-pack-modal__chip-count', text: '· ' + totalCount }));
    filtersEl.appendChild(allChip);

    /* 3 chips de intensidad — solo si hay al menos 1 producto en esa categoría.
       Orden fijo: Suave → Media → Intensa (UX ascendente). */
    ['Suave', 'Media', 'Intensa'].forEach(function (intens) {
      if (byIntensity[intens] === 0) return;
      var chip = el('button', {
        cls: 'lj-pack-modal__chip',
        attrs: { 'type': 'button', 'data-filter': intens, 'role': 'tab', 'aria-selected': 'false' }
      });
      /* Icono visual sutil para reforzar jerarquía */
      var icon = intens === 'Suave' ? '🌿 ' : intens === 'Media' ? '✨ ' : '🔥 ';
      chip.appendChild(document.createTextNode(icon + 'Intensidad ' + intens));
      chip.appendChild(el('span', { cls: 'lj-pack-modal__chip-count', text: '· ' + byIntensity[intens] }));
      filtersEl.appendChild(chip);
    });
  }

  function applyFilter(filterValue) {
    state.activeFilter = filterValue;
    var chips = filtersEl.querySelectorAll('.lj-pack-modal__chip');
    for (var i = 0; i < chips.length; i++) {
      var active = chips[i].getAttribute('data-filter') === filterValue;
      chips[i].classList.toggle('is-active', active);
      chips[i].setAttribute('aria-selected', active ? 'true' : 'false');
    }
    var cards = productsEl.querySelectorAll('.lj-pack-product');
    for (var j = 0; j < cards.length; j++) {
      var c = cards[j];
      /* Filtramos por data-product-intensidad (ya escrito en renderProductCard). */
      var prodIntens = c.getAttribute('data-product-intensidad') || '';
      var hide = filterValue !== 'all' && prodIntens !== filterValue;
      c.setAttribute('data-hidden-by-filter', hide ? '1' : '0');
    }
  }

  /* ========== RENDER ========== */
  function buildSlotEls(count) {
    clearChildren(slotsEl);
    var isWizard = state.activePack && !!state.activePack.slot_collections;
    for (var i = 0; i < count; i++) {
      var cls = 'lj-pack-modal__slot';
      if (isWizard) cls += ' is-clickable';
      var slotEl = el(isWizard ? 'button' : 'div', {
        cls: cls,
        attrs: isWizard
          ? { 'data-slot': i, 'data-lj-pack-go-step': i, 'type': 'button', 'aria-label': 'Ir al paso ' + (i + 1) }
          : { 'data-slot': i }
      });
      slotsEl.appendChild(slotEl);
    }
  }

  function renderProductCard(product, slotIndex) {
    var intensidad = intensidadOf(product.handle) || '';
    var isUnavailable = product.available === false;
    var cardAttrs = {
      'type': 'button',
      'data-product-handle': product.handle,
      'data-product-variant': product.variant_id,
      'data-product-title': product.title,
      'data-product-type': product.product_type || '',
      'data-product-intensidad': intensidad,
      'data-product-price': product.price,
      'data-product-compare-at': product.compare_at_price || '',
      'data-product-image': product.image || '',
      'data-slot-group': slotIndex,
      'data-count': '0',
    };
    if (isUnavailable) {
      /* NO usamos `disabled` HTML porque previene el click event y
         no llegariamos a `flashCard()`. Con `data-unavailable` el click
         si llega, toggleProduct hace flashCard, y guardamos la guardia
         de no agregar al state. */
      cardAttrs['data-unavailable'] = 'true';
      cardAttrs['aria-disabled'] = 'true';
      cardAttrs['title'] = 'Producto agotado';
    }
    var card = el('button', {
      cls: 'lj-pack-product' + (isUnavailable ? ' is-unavailable' : ''),
      attrs: cardAttrs
    });

    /* Badge AGOTADO (Pedro 2026-05-11): pildora visible para productos
       no disponibles. Reemplaza el silent fail anterior donde el cliente
       seleccionaba un agotado y el error solo aparecia en consola. */
    if (isUnavailable) {
      card.appendChild(el('span', { cls: 'lj-pack-product__soldout-badge', text: 'AGOTADO' }));
    }

    /* Count badge "×N" — CLICKEABLE para decrementar (Pedro 2026-05-07).
       Visual: "−" cuando count=1 (signal claro de "click para quitar"),
              "×N" cuando count>1 (counter + remove visual unified).
       data-action="remove" lo identifica en el delegated click handler. */
    var countBadge = el('button', {
      cls: 'lj-pack-product__count',
      attrs: {
        'type': 'button',
        'data-action': 'remove',
        'aria-label': 'Quitar uno de este producto'
      }
    });
    countBadge.appendChild(el('span', { text: '−', attrs: { 'data-count-label': '' } }));
    card.appendChild(countBadge);

    /* Media */
    var media = el('div', { cls: 'lj-pack-product__media' });
    if (product.image) {
      /* loading=eager + image.decode() (Pedro 2026-05-07): lazy fallaba cuando
         el modal se abria con imagenes no cacheadas (e.g. paper-card tras
         refresh hard). decode() FUERZA al browser a bajar+decodificar
         inmediatamente, no esperar al intersection observer. Sin esto, en
         Chrome con WebP, las descargas paralelas a veces se quedaban con
         complete=true pero sin renderizar el frame al DOM. */
      var img = el('img', { attrs: { src: product.image, alt: product.title, loading: 'eager' } });
      media.appendChild(img);
      if (img.decode) img.decode().catch(function () { /* ignore — render fallback ok */ });
    }
    card.appendChild(media);

    /* Title */
    card.appendChild(el('h4', { cls: 'lj-pack-product__title', text: product.title }));

    return card;
  }

  function renderSlotHeader(label, slotIndex) {
    var header = el('div', { cls: 'lj-pack-modal__slot-header', attrs: { 'data-slot-group': slotIndex } });
    header.appendChild(el('span', { text: label }));
    header.appendChild(el('span', {
      cls: 'lj-pack-modal__slot-header-status',
      text: '— Pendiente',
      attrs: { 'data-slot-status': slotIndex }
    }));
    return header;
  }

  /* Wizard header: solo en modo multi-slot. Muestra "Paso X de N" + titulo
     amigable + boton "Atras" si no estamos en el primer paso. */
  function renderWizardHead(group, slotIndex, totalSteps) {
    var head = el('div', { cls: 'lj-pack-modal__wizard-head' });

    /* Boton atras (oculto en paso 0) */
    var backBtn = el('button', {
      cls: 'lj-pack-modal__wizard-back',
      attrs: {
        'type': 'button',
        'aria-label': 'Volver al paso anterior',
        'data-lj-pack-wizard-back': ''
      }
    });
    if (slotIndex === 0) backBtn.setAttribute('hidden', '');
    backBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
    head.appendChild(backBtn);

    /* Bloque texto: pretitle + title */
    var stepWrap = el('div', { cls: 'lj-pack-modal__wizard-step' });
    var pretitle = group.step_pretitle || ('Paso ' + (slotIndex + 1) + ' de ' + totalSteps);
    var title = group.step_title || ('Elige tu ' + (group.label || 'producto'));
    stepWrap.appendChild(el('p', { cls: 'lj-pack-modal__wizard-pretitle', text: pretitle }));
    stepWrap.appendChild(el('h3', { cls: 'lj-pack-modal__wizard-title', text: title }));
    head.appendChild(stepWrap);

    return head;
  }

  /* renderProducts:
     - Single-slot pack (joemania, bigfamily, etc.): renderiza TODOS los
       productos juntos (modo grid, comportamiento original).
     - Multi-slot pack (joe club): modo WIZARD — renderiza SOLO el slot del
       state.currentStep + un header con "Paso X de N · Elige tu...".
       Despues de seleccionar, auto-advance al siguiente slot. */
  function renderProducts(slotGroups) {
    clearChildren(productsEl);
    state.products = [];
    state.slotGroups = slotGroups;

    var isWizard = !!state.activePack.slot_collections && slotGroups.length > 1;

    if (isWizard) {
      var step = Math.max(0, Math.min(state.currentStep, slotGroups.length - 1));
      var group = slotGroups[step];

      productsEl.appendChild(renderWizardHead(group, step, slotGroups.length));

      group.products.forEach(function (product) {
        if (!product.variant_id) return;
        state.products.push(product);
        productsEl.appendChild(renderProductCard(product, step));
      });
      return;
    }

    /* Single-slot path: comportamiento original */
    slotGroups.forEach(function (group, slotIndex) {
      group.products.forEach(function (product) {
        if (!product.variant_id) return;
        state.products.push(product);
        productsEl.appendChild(renderProductCard(product, slotIndex));
      });
    });
  }

  /* ========== WIZARD NAVIGATION ========== */
  function goToStep(stepIdx) {
    if (!state.activePack.slot_collections) return;
    var max = state.activePack.slot_collections.length - 1;
    state.currentStep = Math.max(0, Math.min(stepIdx, max));
    renderProducts(state.slotGroups);
    /* Re-bind product cards a toggleProduct (ver attachProductHandlers) */
    refreshUI();
    /* Scroll productos al inicio cuando cambias paso */
    productsEl.scrollTop = 0;
  }

  /* Auto-advance: despues de seleccionar en el slot actual, esperar 350ms
     (feedback visual del check) y avanzar al siguiente paso pendiente. Si
     todos los slots estan llenos, no avanza (queda en el ultimo). */
  function maybeAutoAdvance() {
    if (!state.activePack.slot_collections) return;
    var total = state.activePack.slot_collections.length;
    /* Buscar el siguiente slot pendiente desde currentStep+1 */
    for (var i = state.currentStep + 1; i < total; i++) {
      if (getSlotGroupSelectionCount(i) === 0) {
        setTimeout(function (idx) { return function () { goToStep(idx); }; }(i), 350);
        return;
      }
    }
    /* Si llegamos aqui es que todos los siguientes ya estan llenos. Tambien
       chequea si hay alguno anterior pendiente (caso edicion). */
    for (var j = 0; j < state.currentStep; j++) {
      if (getSlotGroupSelectionCount(j) === 0) {
        setTimeout(function (idx) { return function () { goToStep(idx); }; }(j), 350);
        return;
      }
    }
    /* Todos los slots tienen seleccion: no movernos, dejar que el cliente
       vea el ultimo paso completo y haga click en "Continuar con la compra". */
  }

  /* ========== SELECTED ITEMS PANEL ========== */
  function renderSelectedItem(sel, index) {
    /* is-filled: marker para el modo horizontal (single-slot reveal).
       En modo wizard (vertical) la clase tambien se aplica pero el CSS
       no la usa para distinguir, asi que es no-op ahi. */
    var item = el('li', { cls: 'lj-pack-modal__item is-filled' });

    /* Image */
    var imgWrap = el('div', { cls: 'lj-pack-modal__item-img' });
    if (sel.image) {
      var selImg = el('img', { attrs: { src: sel.image, alt: sel.title, loading: 'eager' } });
      imgWrap.appendChild(selImg);
      if (selImg.decode) selImg.decode().catch(function () {});
    }
    item.appendChild(imgWrap);

    /* Info */
    var info = el('div', { cls: 'lj-pack-modal__item-info' });
    info.appendChild(el('p', { cls: 'lj-pack-modal__item-title', text: sel.title }));
    if (sel.price) {
      info.appendChild(el('p', { cls: 'lj-pack-modal__item-price', text: priceFmt(sel.price) }));
    }
    item.appendChild(info);

    /* Remove button */
    var remove = el('button', {
      cls: 'lj-pack-modal__item-remove',
      attrs: {
        'type': 'button',
        'aria-label': 'Quitar ' + sel.title,
        'data-lj-pack-remove': index
      }
    });
    /* SVG icon (×) */
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2.5');
    svg.setAttribute('stroke-linecap', 'round');
    var l1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    l1.setAttribute('x1', '18'); l1.setAttribute('y1', '6');
    l1.setAttribute('x2', '6'); l1.setAttribute('y2', '18');
    var l2 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    l2.setAttribute('x1', '6'); l2.setAttribute('y1', '6');
    l2.setAttribute('x2', '18'); l2.setAttribute('y2', '18');
    svg.appendChild(l1); svg.appendChild(l2);
    remove.appendChild(svg);
    item.appendChild(remove);

    return item;
  }

  /* Placeholder visual para slots aun pendientes en wizard mode. Se ve como
     una fila gris con icono + label "Bolsa — Pendiente"; click jumpea al paso. */
  function renderPendingSlot(slotIdx, label, isCurrent) {
    var row = el('li', {
      cls: 'lj-pack-modal__pending-slot' + (isCurrent ? ' is-current' : ''),
      attrs: { 'data-lj-pack-pending-step': slotIdx, 'role': 'button', 'tabindex': '0' }
    });
    row.appendChild(el('span', {
      cls: 'lj-pack-modal__pending-slot-icon',
      text: String(slotIdx + 1)
    }));
    row.appendChild(el('span', { cls: 'lj-pack-modal__pending-slot-label', text: label || ('Producto ' + (slotIdx + 1)) }));
    row.appendChild(el('span', {
      cls: 'lj-pack-modal__pending-slot-status',
      text: isCurrent ? 'Eligiendo…' : 'Pendiente'
    }));
    return row;
  }

  function renderSelectedList() {
    clearChildren(itemsEl);
    var isWizard = !!state.activePack.slot_collections;

    /* Empty state SOLO si no hay activePack o algo raro. En modo
       fixed-slot reveal (single-slot) siempre renderizamos los slots,
       llenos o vacios — no hay empty state. */
    itemsEmptyEl.style.display = 'none';
    itemsEl.style.display = '';

    if (isWizard) {
      /* Multi-slot wizard: 1 fila por slot_collections, vertical (sin cambio). */
      itemsEl.classList.remove('is-horizontal');
      if (summaryEl) summaryEl.classList.remove('is-horizontal-mode');
      var groups = state.activePack.slot_collections;
      groups.forEach(function (group, slotIdx) {
        var sel = null;
        var selIdx = -1;
        for (var i = 0; i < state.selection.length; i++) {
          if (state.selection[i].slotGroup === slotIdx) {
            sel = state.selection[i];
            selIdx = i;
            break;
          }
        }
        if (sel) {
          itemsEl.appendChild(renderSelectedItem(sel, selIdx));
        } else {
          itemsEl.appendChild(renderPendingSlot(slotIdx, group.label, slotIdx === state.currentStep));
        }
      });
      return;
    }

    /* Single-slot: fixed-slot reveal HORIZONTAL (Pedro 2026-05-07).
       Renderiza SIEMPRE state.activePack.slots filas, lado a lado.
       - Slot con seleccion -> renderSelectedItem (clase is-filled)
       - Slot vacio        -> renderHorizontalEmptySlot (clase is-empty)
       - Primer slot vacio -> tambien is-next (pulso naranja). */
    itemsEl.classList.add('is-horizontal');
    /* Marker en el summary para que el CSS oculte head + progress
       (redundantes con la fila horizontal). */
    if (summaryEl) summaryEl.classList.add('is-horizontal-mode');
    var totalSlots = state.activePack.slots || 0;
    for (var s = 0; s < totalSlots; s++) {
      var sel = state.selection[s];
      if (sel) {
        itemsEl.appendChild(renderSelectedItem(sel, s));
      } else {
        var isNext = (s === state.selection.length);
        itemsEl.appendChild(renderHorizontalEmptySlot(s, isNext));
      }
    }
  }

  /* Empty slot horizontal: cuadrito vacio compacto.
     - Estado normal: solo numero grande centrado, gris suave (sin texto)
     - Estado is-next: numero naranja + pulso + texto "Elige" debajo */
  function renderHorizontalEmptySlot(slotIdx, isNext) {
    var li = el('li', {
      cls: 'lj-pack-modal__item is-empty' + (isNext ? ' is-next' : '')
    });
    li.appendChild(el('div', { cls: 'lj-pack-modal__item-img', text: String(slotIdx + 1) }));
    /* Solo el slot is-next muestra texto guia ("Elige"). Los demas son
       solo numero — visualmente mas limpio, menos crowd. */
    if (isNext) {
      var info = el('div', { cls: 'lj-pack-modal__item-info' });
      info.appendChild(el('p', { cls: 'lj-pack-modal__item-title', text: 'Elige' }));
      li.appendChild(info);
    }
    return li;
  }

  /* ========== SELECTION LOGIC ========== */
  function getSlotGroupSelectionCount(slotIndex) {
    var c = 0;
    for (var i = 0; i < state.selection.length; i++) {
      if (state.selection[i].slotGroup === slotIndex) c++;
    }
    return c;
  }

  function toggleProduct(card) {
    /* Guardia (Pedro 2026-05-11): productos agotados marcados con
       data-unavailable. El listener delegated tambien chequea esto, pero
       lo dejamos defensivo en caso de que el caller venga de otro path. */
    if (card.getAttribute('data-unavailable') === 'true') {
      flashCard(card);
      return;
    }
    var handle = card.getAttribute('data-product-handle');
    var variantId = parseInt(card.getAttribute('data-product-variant'), 10);
    var title = card.getAttribute('data-product-title');
    var price = parseFloat(card.getAttribute('data-product-price')) || 0;
    var compareAt = parseFloat(card.getAttribute('data-product-compare-at')) || null;
    var image = card.getAttribute('data-product-image') || '';
    var slotGroup = parseInt(card.getAttribute('data-slot-group'), 10);

    var isMultiSlot = !!state.activePack.slot_collections;

    if (isMultiSlot) {
      /* Multi-slot: 1 producto por slot. Click toggle (replace o remove). */
      var existingIdx = -1;
      for (var i = 0; i < state.selection.length; i++) {
        if (state.selection[i].slotGroup === slotGroup) { existingIdx = i; break; }
      }
      var didAdd = false;
      if (existingIdx !== -1 && state.selection[existingIdx].handle === handle) {
        /* Click en el ya seleccionado: deseleccionar (cliente cambio de opinion) */
        state.selection.splice(existingIdx, 1);
      } else if (existingIdx !== -1) {
        /* Reemplazar en este slot (cliente picked otra opcion del mismo slot) */
        state.selection[existingIdx] = { handle: handle, variantId: variantId, title: title, price: price, compare_at: compareAt, image: image, slotGroup: slotGroup };
        didAdd = true;
      } else {
        state.selection.push({ handle: handle, variantId: variantId, title: title, price: price, compare_at: compareAt, image: image, slotGroup: slotGroup });
        didAdd = true;
      }
      refreshUI();
      /* Si agregamos/cambiamos seleccion en este slot, auto-advance al siguiente
         paso pendiente. Skip si fue una deseleccion (didAdd=false) — ahi el
         cliente quizas quiere elegir otro de este mismo slot. */
      if (didAdd) maybeAutoAdvance();
      return;
    } else {
      /* Single-slot pack (Pedro 2026-05-05):
         - Click siempre INCREMENTA hasta llenar el pack (1, 2, 3, ×N).
         - Pack full: feedback visual y abort.
         - Para QUITAR un producto: usar el botón × del panel summary lateral
           (renderSelectedItem ya provee este botón).
         - Antes el 2do click DESELECCIONABA, lo que confundía al cliente que
           quería 4 del mismo aroma — necesitaba clickear muchas veces sin
           saber si iba a sumar o restar. */
      var packFull = state.selection.length >= state.activePack.slots;
      if (!packFull) {
        state.selection.push({ handle: handle, variantId: variantId, title: title, price: price, compare_at: compareAt, image: image, slotGroup: slotGroup });
      } else {
        /* Pack full: feedback visual breve, sin acción */
        flashCard(card);
        return;
      }
    }
    refreshUI();
  }

  function flashCard(card) {
    /* Visual cue cuando el pack está full y user hace click en producto nuevo */
    card.style.animation = 'none';
    card.offsetHeight; /* force reflow */
    card.style.animation = 'lj-pack-shake 0.4s ease-out';
    setTimeout(function () { card.style.animation = ''; }, 400);
  }

  function removeSelectionAt(index) {
    if (index < 0 || index >= state.selection.length) return;
    state.selection.splice(index, 1);
    refreshUI();
  }

  /* Decrementa la ultima instancia de un producto (single-slot packs).
     Buscar desde el final asegura que si el cliente eligio Lavanda 3 veces
     y hace click en el badge, quita la ULTIMA Lavanda agregada. */
  function decrementProduct(handle) {
    for (var i = state.selection.length - 1; i >= 0; i--) {
      if (state.selection[i].handle === handle) {
        state.selection.splice(i, 1);
        refreshUI();
        return;
      }
    }
  }

  /* ========== TOTALS CALCULATION ========== */
  function computeTotals() {
    var subtotalCents = 0;       // suma de prices ACTUALES (lo que cobra el cart)
    var compareSumCents = 0;     // suma de compare_at (MSRP — narrativa "29.90 c/u")
    state.selection.forEach(function (s) {
      subtotalCents += Math.round(s.price * 100);
      // s.compare_at puede no existir si el producto no tiene compare price
      var ca = s.compare_at ? Math.round(s.compare_at * 100) : Math.round(s.price * 100);
      compareSumCents += ca;
    });

    /* Pedro reporto 2026-05-06: el subtotal saltaba de "real" (24.90 c/u)
       mientras incompleto a "MSRP" (29.90 c/u) al completar. Sin logica
       narrativa: 1=24.90, 2=49.80, 3=74.70, 4=119.60.

       FIX: el subtotal SIEMPRE usa compareSumCents (29.90 c/u, narrativa
       consistente "estás llevando 4 Joes que normalmente cuestan 29.90 c/u").
       El descuento se acumula desde el PRIMER click (diferencia compare vs
       real) — el cliente ve la promo cobrar valor desde el inicio. Cuando
       el pack se completa, el descuento incluye el discount_code adicional
       de Shopify (JOE-PACK-N). */
    var discountAmountCents = 0;
    if (state.selection.length >= state.activePack.slots) {
      /* Pack completo: aplica el discount_code real de Shopify.
         Total = (sum prices reales) - discount_amount.
         Asi el total del modal coincide con lo que cobra el cart. */
      discountAmountCents = state.activePack.discount_amount_cents || 0;
    }
    var totalCents = subtotalCents - discountAmountCents;
    if (totalCents < 0) totalCents = 0;

    /* Discount visible = diferencia entre el subtotal MSRP y el total real.
       Asi acumula desde el primer click (compare-vs-real por unidad) y
       suma el discount_code cuando se completa. */
    var discountCents = compareSumCents - totalCents;
    if (discountCents < 0) discountCents = 0;

    return {
      subtotal: compareSumCents,            // SIEMPRE 29.90 × N (Pedro 2026-05-06)
      discount: discountCents,
      total: totalCents,
      showDiscount: discountCents > 0,
    };
  }

  /* ========== UI REFRESH ========== */
  function refreshUI() {
    var isWizard = !!state.activePack.slot_collections;

    /* Slot bars
       - Single-slot: barra "filled" si i < selection.length (incremental).
       - Multi-slot wizard: barra "filled" si ese slot tiene seleccion;
         "current" si es el paso activo. */
    var slotEls = slotsEl.querySelectorAll('.lj-pack-modal__slot');
    for (var i = 0; i < slotEls.length; i++) {
      var filled = isWizard
        ? getSlotGroupSelectionCount(i) > 0
        : i < state.selection.length;
      slotEls[i].classList.toggle('is-filled', filled);
      slotEls[i].classList.toggle('is-current', isWizard && i === state.currentStep);
    }

    /* Counter */
    countEl.textContent = String(state.selection.length);
    targetEl.textContent = String(state.activePack.slots);

    /* Card count badges */
    var cards = productsEl.querySelectorAll('.lj-pack-product');
    var byHandle = {};
    state.selection.forEach(function (s) { byHandle[s.handle] = (byHandle[s.handle] || 0) + 1; });
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      var h = card.getAttribute('data-product-handle');
      var n = byHandle[h] || 0;
      card.setAttribute('data-count', String(n));
      var label = card.querySelector('[data-count-label]');
      if (label) {
        /* Cuando hay 1: "−" (signal de "click para quitar").
           Cuando hay 2+: "×N" (counter + remove). */
        label.textContent = n <= 1 ? '−' : ('×' + n);
      }
      card.classList.toggle('is-selected', n > 0);
    }

    /* Multi-slot status */
    if (state.activePack.slot_collections) {
      var statusEls = productsEl.querySelectorAll('[data-slot-status]');
      for (var s = 0; s < statusEls.length; s++) {
        var sg = parseInt(statusEls[s].getAttribute('data-slot-status'), 10);
        var done = getSlotGroupSelectionCount(sg) > 0;
        statusEls[s].textContent = done ? '✓ Elegido' : '— Pendiente';
        statusEls[s].classList.toggle('is-done', done);
      }
    }

    /* Selected items list */
    renderSelectedList();

    /* Totals */
    var totals = computeTotals();
    subtotalEl.textContent = priceFmt(totals.subtotal / 100);
    if (totals.showDiscount) {
      discountRowEl.hidden = false;
      discountEl.textContent = '–' + priceFmt(totals.discount / 100);
    } else {
      discountRowEl.hidden = true;
    }
    totalEl.textContent = priceFmt(totals.total / 100);

    /* CTA button — el texto cambia según modo edit vs nuevo pack */
    var ready = state.selection.length === state.activePack.slots;
    addBtn.disabled = !ready;
    var faltan = state.activePack.slots - state.selection.length;
    var readyLabel = state.editingInstanceId
      ? 'Actualizar pack'
      : 'Continuar con la compra';
    addLabelEl.textContent = ready
      ? readyLabel
      : 'Faltan ' + faltan + ' producto' + (faltan === 1 ? '' : 's');

    /* Mobile: auto-expand sheet cuando hay selecciones (UX hint) */
    if (window.matchMedia('(max-width: 640px)').matches && state.selection.length > 0) {
      summaryEl.classList.add('is-expanded');
    }

    /* Auto-scroll al CTA cuando el pack se completa (transicion no-ready → ready).
       Pedro reporto que en mobile el cliente terminaba de armar el pack pero el
       boton "Continuar con la compra" quedaba debajo del fold. Auto-scroll lo
       trae a la vista. Solo en mobile (<=640px); en desktop el panel es sidebar
       fijo y el CTA siempre visible.

       setTimeout 250ms en lugar de double-rAF: en algunos contextos el rAF
       inner callback no dispara (tab en background, animations en curso, etc).
       250ms da tiempo al reflow del is-expanded sin depender de rAF. */
    if (ready && !state.wasReady) {
      var isMobile = window.matchMedia('(max-width: 640px)').matches;
      if (isMobile && addBtn) {
        setTimeout(function () {
          addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 250);
      }
    }
    state.wasReady = ready;
  }

  /* ========== ADD TO CART ==========
   * NUEVO BEHAVIOR (v3): agregamos los productos INDIVIDUALES al carrito (uno
   * por unidad seleccionada), agrupados por variantId con quantity sumada.
   * Cada line item lleva line item properties identificadoras del pack:
   *   - "Pack" (visible): "Pack Bigfamily"
   *   - "Tipo" (visible): "Joe Club" | "Bolsa" | "Llavero" (solo multi-slot)
   *   - "_pack_id" (hidden, empieza con _): "bigfamily" para tracking
   *   - "_pack_discount_code" (hidden): código de discount automático a aplicar
   *
   * El descuento se aplica vía Shopify Automatic Discount creado por el admin
   * (ver instrucciones en lj-pack-builder.liquid header). Si el descuento NO
   * está configurado todavía, el cart muestra subtotal sin descuento — el
   * cliente paga el precio normal de cada producto individual.
   *
   * Para forzar el descuento via URL discount code (alternativa más resiliente
   * mientras el admin configura los automatic discounts), redirigimos a
   * /discount/{code}/cart si el pack define un discount_code en su config. */
  /**
   * Para edit mode: borra del cart todos los line items que pertenecen
   * al pack instance (por _pack_id matching).
   *
   * Usa /cart/update.js que acepta un map { key: quantity } y aplica TODOS
   * los cambios en UNA sola request atómica. Cero race conditions, cero
   * session lock issues.
   *
   * Historia del bug:
   *   v1: Promise.all paralelo a /cart/change.js → 400 en 2/4 calls (session
   *       lock conflicts) → solo se borraban 2 de 4 items → duplicación.
   *   v2: Sequential reduce-chain a /cart/change.js → seguía dando 400 en
   *       el segundo delete (causa exacta del 400 sin investigar pero
   *       repetible). Peor: dejaba el cart con 1 item borrado y abortaba
   *       sin agregar el nuevo pack → estado inconsistente.
   *   v3 (este): /cart/update.js con todos los keys en una request. Shopify
   *       garantiza atomicidad — o todos los items se actualizan o ninguno.
   *
   * @param {string} instanceId - el _pack_id del pack a remover
   * @returns {Promise} resuelve cuando los items se removieron, rechaza si
   *                   la request falló (addPackToCart aborta antes del add).
   */
  function removeOldPackItems(instanceId) {
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var matchingKeys = (cart.items || [])
          .filter(function (item) {
            return item.properties && item.properties._pack_id === instanceId;
          })
          .map(function (item) { return item.key; });

        if (matchingKeys.length === 0) return null;

        /* Construir el map { key: 0, key2: 0, ... } para /cart/update.js.
           Shopify acepta line item keys como identifiers en el `updates` hash
           y aplica todos los updates atómicamente. */
        var updates = {};
        matchingKeys.forEach(function (key) { updates[key] = 0; });

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) {
          if (!r.ok) {
            return r.text().then(function (body) {
              throw new Error('update.js HTTP ' + r.status + ': ' + body.slice(0, 200));
            });
          }
          return r.json();
        });
      });
    /* NO catch aquí — propagamos el error a addPackToCart para abortar el
       flow ANTES de agregar items nuevos. Sin abort, una falla parcial
       (algunos items borrados, otros no) causaría duplicación. */
  }

  function addPackToCart() {
    if (addBtn.disabled) return;

    /* Agrupar selecciones por variantId — si cliente eligió 2× Vainilla, se
       envía como 1 line item con quantity: 2 (en lugar de 2 line items distintos
       ocupando filas en el cart). */
    var byVariant = {};
    state.selection.forEach(function (sel) {
      var key = String(sel.variantId);
      if (!byVariant[key]) {
        byVariant[key] = {
          id: sel.variantId,
          quantity: 0,
          slotGroup: sel.slotGroup,
          handle: sel.handle,
          title: sel.title,
        };
      }
      byVariant[key].quantity++;
    });

    /* CRITICAL: pack instance ID único — cada vez que se agrega un pack al
       cart, le asignamos un ID único (timestamp + random suffix). Esto hace
       que Shopify trate cada pack como entry SEPARADA en el cart, aunque
       el cliente arme 2 packs idénticos del mismo handle.

       Antes: _pack_id = state.activePack.id (siempre lo mismo, ej. "joemania").
       Resultado: si cliente armaba pack JoeManía (4 vainilla) + otro pack
       JoeManía (4 vainilla), ambos tenían _pack_id="joemania" y Shopify
       AGRUPABA todos los items como un solo line item con quantity:8 — el
       cart mostraba "8 vainillas" en lugar de "2 packs JoeManía".

       Ahora: _pack_id = "joemania-1735754321-x9k2" (único por instancia).
       Cart drawer agrupa items por _pack_id idéntico → cada pack queda
       como su propia card editable. */
    var packInstanceId = state.activePack.id + '-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);

    /* Construir el array de items para /cart/add.js */
    var items = Object.keys(byVariant).map(function (k) {
      var entry = byVariant[k];
      var properties = {
        /* Visible properties (no empiezan con _): aparecen en cart, checkout, email */
        'Pack': state.activePack.title,
      };
      /* Para multi-slot packs (Joe Club): incluir el label del slot ("Joe Club", "Bolsa", "Llavero") */
      if (state.activePack.slot_collections) {
        var slotLabel = state.activePack.slot_collections[entry.slotGroup].label;
        properties['Tipo'] = slotLabel;
      }
      /* Hidden tracking properties (empiezan con _, no visibles al cliente) */
      properties['_pack_id'] = packInstanceId;            /* único por instancia */
      properties['_pack_kind'] = state.activePack.id;     /* tipo del pack (ej. joemania) */
      properties['_pack_handle'] = state.activePack.pack_handle;
      properties['_pack_total_target'] = state.activePack.total_price_display || '';

      return {
        id: entry.id,
        quantity: entry.quantity,
        properties: properties,
      };
    });

    addLabelEl.textContent = state.editingInstanceId ? 'Actualizando…' : 'Agregando…';
    addBtn.disabled = true;

    /* EDIT MODE — si hay editingInstanceId, primero borrar los items
       viejos del pack que se está editando del cart, después agregar
       los nuevos. Esto evita duplicar packs al editar.

       Estrategia: fetch /cart.js → filter line items con _pack_id
       matching → POST /cart/change.js con id=line.key, quantity=0 para
       cada uno (en serie, Shopify no soporta batch removes simples).
       Después continuar con el flow normal de add.js.

       Si NO hay editingInstanceId (modo nuevo pack), saltarse esto y
       agregar normal. */
    var preflight = state.editingInstanceId
      ? removeOldPackItems(state.editingInstanceId)
      : Promise.resolve();

    preflight.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: ['lj-cart-drawer'],
        })
      });
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) {
            throw new Error(err.description || err.message || 'Error al agregar');
          });
        }
        return r.json();
      })
      .then(function (data) {
        var discountCode = state.activePack.discount_code;
        /* Si hay discount code, aplicarlo en background vía Discount API.
           Esto NO redirige — el descuento queda asociado al cart sin
           cambiar de página. */
        var discountPromise = discountCode
          ? fetch('/discount/' + encodeURIComponent(discountCode), { method: 'GET', credentials: 'same-origin' })
              .catch(function () { /* fail silently — el cliente puede aplicar en checkout */ })
          : Promise.resolve();

        return discountPromise.then(function () {
          /* CRITICAL: el sectionHtml de `data.sections['lj-cart-drawer']` viene
             de la respuesta de /cart/add.js — es el HTML del cart drawer
             ANTES de aplicar el discount. Si lo usamos cuando hay discount,
             el cart muestra total SIN descuento (ej. S/.96.80 cuando deberia
             ser S/.88).

             Si hay discountCode aplicado, re-fetch FRESH del drawer para que
             el HTML refleje el precio con descuento. Sin discount, usamos el
             cached que es OK y mas rapido. */
          var freshDrawerPromise;
          if (discountCode) {
            freshDrawerPromise = fetch('/?sections=lj-cart-drawer', { cache: 'no-store' })
              .then(function (r) { return r.json(); })
              .then(function (sections) {
                var freshHtml = sections && sections['lj-cart-drawer'];
                if (freshHtml && typeof window.ljCartApplyHtml === 'function') {
                  window.ljCartApplyHtml(freshHtml);
                }
              })
              .catch(function () {
                /* Fallback: usar el cached aunque no tenga discount */
                var sectionHtml = data.sections && data.sections['lj-cart-drawer'];
                if (sectionHtml && typeof window.ljCartApplyHtml === 'function') {
                  window.ljCartApplyHtml(sectionHtml);
                }
              });
          } else {
            var sectionHtml = data.sections && data.sections['lj-cart-drawer'];
            if (sectionHtml && typeof window.ljCartApplyHtml === 'function') {
              window.ljCartApplyHtml(sectionHtml);
            }
            freshDrawerPromise = Promise.resolve();
          }

          /* Update header pill count (ambos paths llegan aqui) */
          return freshDrawerPromise.then(function () {
            return fetch('/cart.js', { cache: 'no-store' });
          }).then(function (r) {
            return r.json();
          }).then(function (cart) {
            /* Audit: verificar que el discount_code esperado se aplicó.
               Si el cart tenía un código viejo (e.g. JOE-SCENTED-2 stuck de
               sesión previa), Shopify a veces no lo reemplaza inmediato.
               Logueamos en consola para debug; el usuario verá total
               correcto al recargar /cart o re-aplicar manualmente. */
            if (discountCode && cart) {
              var applied = (cart.cart_level_discount_applications || [])
                .map(function (a) { return (a.code || a.title || '').toUpperCase(); });
              if (applied.indexOf(discountCode.toUpperCase()) === -1) {
                if (window.console && console.warn) {
                  console.warn('[lj-pack] Code "' + discountCode + '" no se aplicó. Applied:', applied);
                }
                /* Retry una vez: re-fetch /discount/{code} y refresh drawer */
                return fetch('/discount/' + encodeURIComponent(discountCode), {
                  method: 'GET', credentials: 'same-origin'
                }).then(function () {
                  return fetch('/?sections=lj-cart-drawer', { cache: 'no-store' });
                }).then(function (r2) { return r2.json(); }).then(function (sections2) {
                  var freshHtml2 = sections2 && sections2['lj-cart-drawer'];
                  if (freshHtml2 && typeof window.ljCartApplyHtml === 'function') {
                    window.ljCartApplyHtml(freshHtml2);
                  }
                  return fetch('/cart.js', { cache: 'no-store' });
                }).then(function (r3) { return r3.json(); }).then(function (cart2) {
                  return cart2;
                }).catch(function () { return cart; });
              }
            }
            return cart;
          }).then(function (cart) {
            if (typeof window.ljCartUpdateHeaderCount === 'function') {
              window.ljCartUpdateHeaderCount(cart);
            } else {
              /* Fallback inline si el helper no está expuesto: actualizar pill
                 directamente con DOM (sin innerHTML) */
              var pill = document.querySelector('.lj-cart-pill');
              if (pill) {
                var amt = pill.querySelector('.lj-cart-pill__amount');
                if (amt) amt.textContent = 'S/. ' + (cart.total_price / 100).toFixed(2);
                var countEl = pill.querySelector('.lj-cart-pill__count');
                if (cart.item_count > 0) {
                  if (!countEl) {
                    countEl = document.createElement('span');
                    countEl.className = 'lj-cart-pill__count';
                    pill.appendChild(countEl);
                  }
                  countEl.textContent = String(cart.item_count);
                }
              }
            }
            /* Cerrar modal del pack builder + abrir drawer del carrito.
               Usamos `lj:cart:request-open` (no `lj:cart:open`) porque el
               último es la NOTIFICACIÓN que dispara el cart drawer cuando
               él mismo se abre — escucharlo y volver a abrir = loop. */
            closeModal();

            /* CRITICAL: si el upsell modal (z-index 10000) esta abierto,
               TAMBIEN cerrarlo. Sino el cart drawer (z-index 9999) queda
               tapado debajo del upsell y el cliente no ve la suma actualizada
               — exactamente el bug que Pedro reporto: "no se agrega la suma".
               El cart drawer SI tenia el total correcto pero el upsell lo
               tapaba.
               Asi mismo es buen UX: el upsell ya cumplio su funcion (el
               cliente agrego un pack), el siguiente paso natural es ver el
               cart con el nuevo total y proceder al checkout. */
            var upsellModal = document.querySelector('[data-lj-upsell]');
            if (upsellModal && upsellModal.getAttribute('aria-hidden') === 'false') {
              upsellModal.setAttribute('aria-hidden', 'true');
              document.body.classList.remove('lj-upsell-open');
            }

            /* Preferimos llamar el helper directo si está expuesto, sino
               dispatch el event */
            if (typeof window.ljCartOpenDrawer === 'function') {
              window.ljCartOpenDrawer();
            } else {
              document.dispatchEvent(new CustomEvent('lj:cart:request-open'));
            }
            document.dispatchEvent(new CustomEvent('lj:cart:add', {
              detail: { item: data, cart: cart, source: 'pack-builder' }
            }));
          });
        });
      })
      .catch(function (err) {
        console.error('[lj-pack-builder] Add to cart failed:', err);
        addBtn.disabled = false;
        addLabelEl.textContent = 'Error — intenta de nuevo';
        setTimeout(function () { refreshUI(); }, 2500);
      });
  }

  /* ========== OPEN / CLOSE ========== */
  /**
   * Abre el modal del pack-builder.
   * @param {string} packKey - clave del pack en LJ_PACK_CONFIG
   * @param {Array} [preSelection] - selección previa para edit mode.
   *   Cada item: {handle, variantId, title, price, image, slotGroup}
   * @param {string} [editingInstanceId] - _pack_id del pack en cart que
   *   se está editando. Si presente, al guardar se REEMPLAZA ese pack
   *   (borra los items viejos antes de agregar los nuevos). Sin este flag,
   *   "guardar" agrega un pack NUEVO (comportamiento default).
   */
  function openModal(packKey, preSelection, editingInstanceId) {
    var pack = (window.LJ_PACK_CONFIG || {})[packKey];
    if (!pack) {
      console.warn('[lj-pack-builder] Pack no encontrado:', packKey);
      return;
    }
    if (!modal && !initRefs()) return;

    state.activePack = pack;
    state.selection = [];  // se rellenará después de fetch si hay preSelection
    state.activeFilter = 'all';
    state.isOpen = true;
    state.editingInstanceId = editingInstanceId || null;  // null = nuevo pack, string = edit mode
    state.currentStep = 0;  // wizard mode arranca siempre en el primer paso
    /* Reset wasReady: si abren un pack en edit mode con selection ya completa,
       el primer refreshUI() dispara wasReady=true SIN scroll (no es transicion
       genuina, ya estaba lleno). Si abren pack nuevo, arranca en false y
       cuando completan, hace scroll. Reset aqui es safe en ambos casos. */
    state.wasReady = false;

    titleEl.textContent = pack.title;
    subtitleEl.textContent = pack.subtitle || '';

    /* % OFF badges (chip al lado del título + banner sobre totales).
       Calcula desde total_compare_cents / total_price_cents para que
       siempre coincida con la matemática del modal — no hace falta
       agregar un campo "discount_percent" al config. */
    var pctOff = 0;
    if (pack.total_compare_cents && pack.total_compare_cents > pack.total_price_cents) {
      pctOff = Math.round((1 - pack.total_price_cents / pack.total_compare_cents) * 100);
    }
    if (pctOff > 0) {
      /* Badge circular en el header — promesa visible desde el inicio */
      if (discountCircleEl && discountPctEl) {
        discountPctEl.textContent = pctOff + '%';
        discountCircleEl.hidden = false;
        discountCircleEl.setAttribute('aria-hidden', 'false');
        discountCircleEl.setAttribute('aria-label', pctOff + ' por ciento de descuento');
      }
      /* Chip viejo (legacy, ya no esta en el HTML pero el JS lo soporta
         por si algun theme custom lo tiene) */
      if (discountChipEl) {
        discountChipEl.textContent = pctOff + '% OFF';
        discountChipEl.hidden = false;
      }
      if (discountBannerEl && discountBannerPercentEl) {
        discountBannerPercentEl.textContent = pctOff + '%';
        discountBannerEl.hidden = false;
      }
    } else {
      if (discountCircleEl) {
        discountCircleEl.hidden = true;
        discountCircleEl.setAttribute('aria-hidden', 'true');
      }
      if (discountChipEl) discountChipEl.hidden = true;
      if (discountBannerEl) discountBannerEl.hidden = true;
    }

    buildSlotEls(pack.slots);

    productsEl.hidden = true;
    errorEl.hidden = true;
    loadingEl.style.display = '';
    addBtn.disabled = true;
    addLabelEl.textContent = 'Cargando…';

    /* Reset filter chips */
    clearChildren(filtersEl);
    /* Reset summary panel */
    clearChildren(itemsEl);
    summaryEl.classList.remove('is-expanded');
    if (subtotalEl) subtotalEl.textContent = priceFmt(0);
    if (totalEl) totalEl.textContent = pack.total_price_display || priceFmt(pack.total_price_cents / 100);
    if (discountRowEl) discountRowEl.hidden = true;

    modal.hidden = false;
    document.body.classList.add('lj-pack-modal-open');

    fetchEligibleProducts(pack)
      .then(function (slotGroups) {
        loadingEl.style.display = 'none';
        productsEl.hidden = false;
        renderProducts(slotGroups);
        buildFilters(slotGroups);

        /* Edit mode: pre-llenar state.selection con los items del cart
           que pertenecen a este pack. Después marcar visualmente las
           cards correspondientes como seleccionadas.

           PRICING (BUG FIX 2026-05-06): NUNCA usar price/compare_at del
           preSelection (que viene del cart). El cart line tiene:
             - final_price: post-discount-code (con JOE-PACK-N aplicado)
             - original_price: pre-discount-code (precio del producto)
             - NO TIENE compare_at_price del producto (eso es de Shopify
               product API, no de cart API)
           Si usamos final_price, en edit mode aplicamos el discount DOS
           veces (cart ya lo restó + modal lo resta de nuevo) → total
           S/76.40 cuando debería ser S/88.
           Solución: leer price y compare_at desde state.products (fetch
           autoritativo del producto). El cart solo nos dice qué variantId
           pertenece al pack, no a qué precio. Pedro reportó esto. */
        if (Array.isArray(preSelection) && preSelection.length > 0) {
          /* Lookup completo: en multi-slot packs (Joe Club) state.products
             solo tiene productos del wizard step ACTUAL, pero state.slotGroups
             tiene TODOS los slots desde el primer fetch. Iteramos todos para
             que joe / bolsa / llavero (en slots distintos) se encuentren. */
          var productByVariant = {};
          (state.slotGroups || []).forEach(function (group, slotIdx) {
            (group.products || []).forEach(function (p) {
              if (p.variant_id) {
                productByVariant[String(p.variant_id)] = { product: p, slotIdx: slotIdx };
              }
            });
          });
          preSelection.forEach(function (item) {
            if (item && item.variantId) {
              var entry = productByVariant[String(item.variantId)];
              var prod = entry ? entry.product : null;
              /* slotGroup: derivado del lookup (correcto para multi-slot)
                 con fallback al item.slotGroup si lookup falla. */
              var slotGroup = entry ? entry.slotIdx : (item.slotGroup || 0);
              state.selection.push({
                handle: item.handle || '',
                variantId: String(item.variantId),
                title: (prod && prod.title) || item.title || '',
                price: prod ? prod.price : (item.price || 0),                       /* price del fetch, no del cart */
                compare_at: prod ? prod.compare_at_price : (item.compare_at || null), /* compare_at del fetch */
                image: (prod && prod.image) || item.image || '',
                slotGroup: slotGroup,
              });
            }
          });
          /* En edit mode, el pack arranca completo sin que el user haya
             interactuado. Set wasReady=true para evitar el auto-scroll
             del primer refreshUI (no es transicion genuina del user). */
          if (state.activePack && state.selection.length === state.activePack.slots) {
            state.wasReady = true;
          }
          /* Mark visually as selected en las cards */
          state.selection.forEach(function (sel) {
            var card = productsEl.querySelector('[data-variant-id="' + sel.variantId + '"]');
            if (card) {
              card.classList.add('is-selected');
              /* Si la card tiene un counter visible, actualizarlo */
              var counter = card.querySelector('[data-lj-pack-card-count]');
              if (counter) {
                var qty = state.selection.filter(function (s) {
                  return String(s.variantId) === String(sel.variantId);
                }).length;
                counter.textContent = qty > 1 ? '×' + qty : '';
              }
            }
          });
        }

        refreshUI();
      })
      .catch(function (err) {
        console.error('[lj-pack-builder] Fetch failed:', err);
        loadingEl.style.display = 'none';
        errorEl.hidden = false;
      });
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('lj-pack-modal-open');
    state.isOpen = false;
    state.selection = [];
  }

  /* ========== EVENT BINDING ========== */
  function bindEvents() {
    document.addEventListener('click', function (e) {
      /* Trigger global: data-pack-id="<handle>" */
      var trigger = e.target.closest('[data-pack-id]');
      if (trigger) {
        var packKey = trigger.getAttribute('data-pack-id');
        if (packKey && (window.LJ_PACK_CONFIG || {})[packKey]) {
          e.preventDefault();
          openModal(packKey);
        }
        return;
      }

      if (modal && state.isOpen) {
        /* Filter chip */
        var chip = e.target.closest('[data-filter]');
        if (chip && filtersEl.contains(chip)) {
          applyFilter(chip.getAttribute('data-filter'));
          return;
        }
        /* Wizard "Atras" button (solo en multi-slot) */
        var wizBack = e.target.closest('[data-lj-pack-wizard-back]');
        if (wizBack) {
          goToStep(state.currentStep - 1);
          return;
        }
        /* Slot bar clickable (jump al paso N en wizard mode) */
        var goStep = e.target.closest('[data-lj-pack-go-step]');
        if (goStep) {
          goToStep(parseInt(goStep.getAttribute('data-lj-pack-go-step'), 10));
          return;
        }
        /* Pending slot row (en panel summary) tambien jumpea al paso */
        var pendingSlot = e.target.closest('[data-lj-pack-pending-step]');
        if (pendingSlot) {
          goToStep(parseInt(pendingSlot.getAttribute('data-lj-pack-pending-step'), 10));
          return;
        }
        /* Remove button (× en panel derecho) */
        var removeBtn = e.target.closest('[data-lj-pack-remove]');
        if (removeBtn) {
          var idx = parseInt(removeBtn.getAttribute('data-lj-pack-remove'), 10);
          removeSelectionAt(idx);
          return;
        }
        /* Sheet toggle (mobile) */
        var sheet = e.target.closest('[data-lj-pack-sheet-toggle]');
        if (sheet) {
          summaryEl.classList.toggle('is-expanded');
          return;
        }
        /* Badge counter del card -> decrementa (Pedro 2026-05-07).
           IMPORTANTE: este check va ANTES del product card check, porque
           el badge esta DENTRO del card. closest('.lj-pack-product')
           tambien lo capturaria si lo dejamos despues. */
        var countBadgeBtn = e.target.closest('.lj-pack-product__count[data-action="remove"]');
        if (countBadgeBtn) {
          var parentCard = countBadgeBtn.closest('.lj-pack-product');
          if (parentCard) {
            decrementProduct(parentCard.getAttribute('data-product-handle'));
          }
          return;
        }
        /* Product card */
        var card = e.target.closest('.lj-pack-product');
        if (card) {
          toggleProduct(card);
          return;
        }
        /* Close triggers */
        if (e.target.closest('[data-lj-pack-close]')) {
          closeModal();
          return;
        }
        /* CTA add button */
        if (e.target.closest('[data-lj-pack-add]')) {
          addPackToCart();
        }
      }
    });

    /* ESC para cerrar */
    document.addEventListener('keydown', function (e) {
      if (state.isOpen && e.key === 'Escape') closeModal();
    });
  }

  /* ========== AUTO-OPEN desde URL hash ========== */
  /* Cuando el cliente hace click "Editar pack" en /cart, el JS lo redirige a
     /pages/landing-little-joe#open-pack=<handle>. Aquí detectamos ese hash y
     abrimos el modal automáticamente. */
  function checkAutoOpen() {
    var hash = window.location.hash || '';
    var match = hash.match(/open-pack=([^&]+)/);
    if (!match) return;
    var handle = decodeURIComponent(match[1]);
    if (!(window.LJ_PACK_CONFIG || {})[handle]) return;

    /* Lee también el flag edit-instance=<id> si existe — significa que el
       cliente clickeó "Editar pack" desde el cart drawer y fue redirigido
       acá. Necesitamos cargar la preSelection del cart + pasar el
       editingInstanceId al openModal para que al guardar reemplace el pack. */
    var editMatch = hash.match(/edit-instance=([^&]+)/);
    var editingInstanceId = editMatch ? decodeURIComponent(editMatch[1]) : null;

    /* Limpiar hash para no re-abrir al recargar */
    history.replaceState(null, '', window.location.pathname + window.location.search);

    /* Si hay editingInstanceId, fetch cart para construir preSelection.

       PRICING (BUG FIX 2026-05-06): NO pasamos price ni compare_at — el
       openModal los lee de state.products (fetch autoritativo). Si pasamos
       el price del cart, en edit mode aplicamos el discount DOS veces
       (cart ya lo descontó + modal lo descuenta) → total S/76.40 vs S/88
       esperado. Solo pasamos variantId + metadata fallback. */
    var preSelectionPromise = editingInstanceId
      ? fetch('/cart.js', { cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var matching = (cart.items || []).filter(function (i) {
              return i.properties && i.properties._pack_id === editingInstanceId;
            });
            var preSelection = [];
            matching.forEach(function (i) {
              for (var q = 0; q < i.quantity; q++) {
                preSelection.push({
                  handle: i.handle,
                  variantId: i.variant_id,
                  title: i.product_title,
                  image: i.image,
                  slotGroup: 0,
                });
              }
            });
            return preSelection;
          })
          .catch(function () { return null; })
      : Promise.resolve(null);

    /* Esperar a que el trigger CTA exista (el bundle card debe estar montado) */
    preSelectionPromise.then(function (preSelection) {
      var attempts = 0;
      var maxAttempts = 20;
      function tryOpen() {
        attempts++;
        var trigger = document.querySelector('[data-pack-id="' + handle + '"]');
        if (trigger) {
          openModal(handle, preSelection, editingInstanceId);
        } else if (attempts < maxAttempts) {
          setTimeout(tryOpen, 150);
        }
      }
      tryOpen();
    });
  }

  /* ========== BOOT ========== */
  function boot() {
    if (initRefs()) {
      bindEvents();
      checkAutoOpen();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ========== PUBLIC API ==========
     Exponer openModal en window para que el cart drawer pueda abrir el
     pack-builder cuando el cliente clickea "Editar pack". Si no estás en
     una página con pack-builder cargado, no haces nada.
     LJ_PACK_CONFIG vive global; si tiene el packKey, openModal funciona.

     @param {string} packKey
     @param {Array} [preSelection] - items del cart con _pack_id matching
       para edit mode. Si presente, el modal abre con el pack ya armado.
  */
  window.openPackBuilder = function (packKey, preSelection, editingInstanceId) {
    if (!packKey) return false;
    if (!(window.LJ_PACK_CONFIG || {})[packKey]) return false;
    if (!modal && !initRefs()) return false;
    openModal(packKey, preSelection, editingInstanceId);
    return true;
  };
})();
